import React, { useEffect, useRef } from 'react';

const AD_CLIENT = 'ca-pub-1415950205717329';

// AdSense display slot. Renders a labelled "briefing" container. Real ads fill in
// once the AdSense account + domain are approved and a real data-ad-slot is set.
export default function AdSlot({ slot = '', label = 'Sponsored', testid = 'adsense-slot', style }) {
  const ref = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* not approved yet */ }
  }, []);

  return (
    <div className="so-ad" data-testid={testid} style={style}>
      <div className="so-ad-label">{label} · Advertisement</div>
      <ins ref={ref} className="adsbygoogle so-ad-ins"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true" />
      <div className="so-ad-fallback">Your ad could be here</div>
    </div>
  );
}
